import { InvoicesVersionsService_invoiceVersionsServiceGetGetLatest } from '@festina/moneyin-general-types/moneyin/hooks/InvoicesVersionsService_invoiceVersionsServiceGetGetLatest'

export const useFetchInvoiceVersionLatestNoSuspense =
  InvoicesVersionsService_invoiceVersionsServiceGetGetLatest.useQuery
